globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.Modal = (function () {

  function Modal($html) {
    this.$html = $html;
    this.$form = $html.find("form");
    this.zIndex = 1040;
  }

  Modal.mountCurrentModal = function ($html) {
    appCustomerSpace.Loader().stop();

    if ($.fn.modal instanceof Function) {
      $html.modal({ keyboard: false });
    }

    if (jQuery.contains(document.body, $html[0])) {
      $('body').append($html);
    }

    appCustomerSpace.currentModal = appCustomerSpace.Modal.getModalObject($html);

    return appCustomerSpace.currentModal;
  }

  Modal.getModalObject = function ($html) {
    var jsModal = $html.data('js-modal') || {},
      namespace = jsModal.namespace,
      module = jsModal.module;

    if (module) {
      if (namespace) {
        if (appCustomerSpace.Modals[namespace]) {
          if (appCustomerSpace.Modals[namespace].hasOwnProperty(module) && appCustomerSpace.Modals[namespace][module] instanceof Function) {
            return new appCustomerSpace.Modals[namespace][module]($html);
          } else {
            console.log('Module non défini');
            return;
          }
        } else {
          console.log('Namespace non défini');
          return;
        }
      } else {
        if (appCustomerSpace.Modals.hasOwnProperty(module) && appCustomerSpace.Modals[module] instanceof Function) {
          return new appCustomerSpace.Modals[module]($html);
        } else {
          return new Modal($html);
        }
      }
    } else {
      return new Modal($html);
    }
  };

  $.extend(Modal.prototype, {
    init: function () {
      var modal = this;
      modal.initializeClasses();
      modal.closeEvents();
      modal.submitEvents();

      var $autofocus = this.$html.find('input[autofocus]');

      if ($autofocus.length) {
        document.activeElement.blur();
        $autofocus[0].focus();
      }

      return this;
    },
    getPositionType: function () {
      return this.$html.data('position-type');
    },
    initializeClasses: function () {
      var modal = this;

      if (modal.$html.hasClass('initialized')) return this;
      modal.$html.addClass('initialized');
    },
    closeEvents: function () {
      var modal = this;
      modal.$html.on('hidden.bs.modal', function (e) {
        if (!modal.$html.hasClass('modal-inline')) {
          modal.$html.remove();
        }
        if (modal.getLevel() === 1) $('.main-content').removeClass('no-scroll');
        modal.close();
      })

      modal.$html.on('click', '*[type="close"]', function (e) {
        e.preventDefault();
        modal.close();
        $('body').removeClass('modal-open');
      });
    },
    submitEvents: function () {
      var modal = this;

      modal.$html.find('form').not('.modal-skip-submit-event').on('submit', function (e) {
        var $form = $(this);

        if ($form.data('ajax') != undefined && $form.data('ajax') == false) {
          return modal.close();
        }

        appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-content') });

        modal.submit();
        return false;
      });
    },
    open: function (options, callback) {
      var _this = this;

      this.$html.find('.modal-content').prepend('<div class="modal-overlay-before-init" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #fff; z-index: 1000;"></div>');

      if (!this.$html) {
        console.log('Modale non définie');
        return false;
      }

      if (_this.getPositionType() && _this.getPositionType() == 'relative-opener') {
        _this.setPosition();
      }

      _this.setBackDropLevel();

      this.applyOptions(options);

      if (options.keepscroll == null) {
        $('.main-content').addClass('no-scroll');
      }

      this.$html.fadeIn(300, function () {
        if (options.skipPluginsInitialization == null || !options.skipPluginsInitialization) {
          appCustomerSpace.LimitlessPlugins.initPlugins(_this.$html);
          appCustomerSpace.Plugins.initPlugins(_this.$html);
          appCustomerSpace.Modules.initModules(_this.$html);
        }

        _this.$html.find('.modal-overlay-before-init').fadeOut(function () {
          $(this).remove();
        });


        if (!_this.$html.hasClass('initialized')) {
          _this.init();
        }

        if (typeof callback === 'function') {
          return callback();
        }
      });
      if (options.focus != null) {
        this.$html.find('input[data-autofocus="true"]').first().focus();
      }
      return this;
    },
    close: function (callback) {
      var modal = this;
      if (modal.$html != null) {
        modal.$html.modal('hide');
        if (modal.getLevel() === 1) {
          $('.main-content').removeClass('no-scroll');
          appCustomerSpace.currentModal = null;
        } else {
          appCustomerSpace.currentModal = modal.subModal();
        }

        if (typeof callback === "function") {
          return callback();
        }
      }
    },
    subModal: function () {
      var modal = this;
      if (modal.getLevel() === 1) return;

      var $subModal = $('.modal').filter(function () {
        if ($(this).data('level') === modal.getLevel() - 1) return $(this);
      }) || $('.modal:first');

      return $subModal.length ? Modal.getModalObject($subModal) : null;
    },
    applyOptions: function (options) {
      this.options = options;

      if (options.backdrop) {
        $(".modal-backdrop").last().addClass('backdrop-' + options.backdrop);
      }

      options.modalLevel = options.modalLevel || 1;
      this.$html.css('z-index', 7100 + options.modalLevel);
      this.setLevel(options.modalLevel);

      if (options.focus && options.focus.length > 0) {
        return this.$html.find("*[name=" + options.focus).first().focus();
      }
    },
    setPosition: function () {
      var modal = this,
        $modalDialog = modal.$html.find('.modal-dialog'),
        opener = appCustomerSpace.currentModalOpener,
        $opener = opener.$html,
        windowMidHeight = $(window).height() / 2,
        openerIsInTopOfWindow = ($opener.offset().top - $(document).scrollTop()) < windowMidHeight ? true : false;

      if (openerIsInTopOfWindow) {
        $modalDialog.css({
          top: Math.abs(($opener.offset().top - $(document).scrollTop()) + $opener[0].getBoundingClientRect().height + 10) + 'px',
        })
      } else {
        $modalDialog.css({
          bottom: Math.abs(($opener.offset().top - $(document).scrollTop()) - $(window).height() - 10) + 'px',
        })
      }

      $modalDialog.css({
        position: 'absolute',
        width: 'inherit',
        margin: 'inherit',
        marginTop: 'inherit',
        marginBottom: 'inherit',
        right: Math.abs($(window).width() - ($opener.offset().left + $opener[0].getBoundingClientRect().width)) + 'px'
      }).find('.modal-content').css({
        marginRight: 0
      });
    },
    setBackDropLevel: function () {
      var modal = this,
        $backdrop = $(".modal-backdrop").last(),
        zIndex = modal.zIndex + (10 * $(".modal:visible").length);

      $backdrop.css("z-index", zIndex);
    },
    getDOMId: function () {
      return this.$html.attr('id');
    },
    getTargetDOMid: function () {
      return this.$html.data('target');
    },
    getTargetDOM: function () {
      var $target, targetId;
      targetId = this.getTargetDOMid();
      $target = $("#" + targetId);
      if ($target.length) {
        return $target;
      } else {
        return false;
      }
    },
    setLevel: function (level) {
      return this.$html.data('level', level);
    },
    getLevel: function () {
      return this.$html.data('level') || 1;
    },
    submit: function (params) {
      var $form, url, values;
      if (params == null) {
        params = {};
      }
      if (params.callbackSuccess == null) {
        params.callbackSuccess = (function (_this) {
          return function (data) {
            return _this.callbackSuccess(data);
          };
        })(this);
      }
      if (params.callbackError == null) {
        params.callbackError = (function (_this) {
          return function (data) {
            return _this.callbackError(data);
          };
        })(this);
      }
      $form = this.$html.find('form').first();
      values = $form.serialize();
      url = $form.attr('action');
      return $.post(url, values, params.callbackSuccess, 'json').fail(params.callbackError);
    },
    callbackSuccess: function (data, successMsg) {
      if (data == null) {
        data = {};
      }
      if (data.response) {
        this.updateView(data);
        this.close();
      }
    },
    callbackError: function (data) { },
    updateView: function (response) { }
  });

  return Modal;

})();

appCustomerSpace.ModalOpener = (function () {

  ModalOpener.MAIN_CLASS = 'open-modal';

  function ModalOpener($html) {
    this.$html = $html;
    this.options = {};
    if (this.$html.hasClass(ModalOpener.MAIN_CLASS)) {
      this.$html;
    }
  }

  ModalOpener.openModalFromElement = function ($element, callback) {
    $element.tooltip('hide');
    $('body').trigger('modals.opening', [$element]);

    var opener = new ModalOpener($element);
    opener.openModal();

    var backdropColor;
    switch (opener.options.backdrop) {
      case 'black':
        backdropColor = 'rgba(0,0,0,0.5)';
        break;
      case 'white':
        backdropColor = 'rgba(255,255,255,0.5)';
        break;
      case 'transparent':
      case 'blured':
        backdropColor = 'transparent';
        break;
      default:
        backdropColor = 'rgba(42, 57, 82, 0.5)';
        break;
    }

    appCustomerSpace.Loader().start({
      options: {
        text: false,
        icon_size: '2x',
        spinner: (opener.options.backdrop && opener.options.backdrop == 'transparent') ? false : true,
        style: {
          backdrop: {
            background: backdropColor,
            backdropFilter: 'blur(3px)'
          },
          spinner: {
            color: '#FFF'
          }
        }
      }
    });

    if (callback instanceof Function) {
      callback(opener);
    }
  };

  ModalOpener.initModalOpeners = function (callback) {
    $('body').on('click', "." + ModalOpener.MAIN_CLASS, function (e) {
      e.preventDefault();
      ModalOpener.openModalFromElement($(this), callback);
      return false;
    });

    return $(window).keydown(function (e) {
      if (e.which === 27) {
        if (appCustomerSpace.currentModal) {
          appCustomerSpace.currentModal.close();
        } else {
          ModalOpener.abortXHR();
          appCustomerSpace.Loader().stop();
        }
      }
    });
  };

  ModalOpener.abortXHR = function () {
    if (this.XHR) {
      return this.XHR.abort();
    }
  }

  ModalOpener.openFromUrlParam = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var openModalParam = urlParams.get('open_modal');

    if (!openModalParam) {
      return;
    }

    setTimeout(function () {
      var $virtualButton = $('<a>', {
        class: 'open-modal',
        'data-modal-url': openModalParam
      });

      ModalOpener.openModalFromElement($virtualButton);
    }, 100);
  }

  ModalOpener.prototype = {
    getModalTarget: function (callback) {
      var data, self, url;
      self = this;
      data = {};
      url = this.$html.data('modal-url'),
        selector = this.$html.data('modal-selector');

      if ((url === '' || url === undefined) && (selector === '' || selector === undefined)) {
        console.log('Modal url/selector not specified');
        return;
      }

      this.options = this.getOptions();
      if (this.options.data) {
        data = $.extend(data, this.options.data);
      }

      if (selector != undefined) {
        $modal = $(selector);
        appCustomerSpace.Loader().stop();

        if ($modal.length) {
          appCustomerSpace.Modal.mountCurrentModal($modal);
          appCustomerSpace.currentModalOpener = self;
          return callback(appCustomerSpace.currentModal);
        }
      }

      return this.constructor.XHR = $.get(url, data, (function (_this) {
        return function (data, response, xhr) {
          _this.constructor.XHR = false;
          if (data.response) {
            appCustomerSpace.Modal.mountCurrentModal($(data.html));
            appCustomerSpace.currentModalOpener = self;
            return callback(appCustomerSpace.currentModal);
          } else {
            return appCustomerSpace.Loader().stop();
          }
        };
      })(this), 'json').fail(function () {
        appCustomerSpace.Loader().stop();
        return console.log('Erreur de chargement');
      });
    },
    getOptions: function () {
      var options;
      options = this.$html.data('modal-options') || {};
      options.modalLevel = options.modalLevel != null ? parseInt(options.modalLevel) : 1;
      return options;
    },
    openModal: function () {
      var _this = this;
      return _this.getModalTarget(function (modal) {
        return modal.open(_this.options);
      });
    }
  }

  return ModalOpener;
})();
